/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'boxicons/css/boxicons.min.css';
import 'react-notifications/lib/notifications.css';
import './styles/loader-bouncing.css';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import { NotificationContainer } from 'react-notifications';

// Import Pages.
import Login from './pages/Login';
import Home from './pages/Home';
import Vacaciones from './pages/Vacaciones';
import SolicVacacion from './pages/SolicVacacion';
import Solicitudes from './pages/Solicitudes';
import Marcaciones from './pages/Marcaciones';
import Usuarios from './pages/Usuarios';
import Menus from './pages/Menus';
import SolicEmpleo from './pages/SolicEmpleo';
import MiPerfil from './pages/MiPerfil';
import Localizaciones from './pages/Localizaciones';
import Perfiles from './pages/Perfiles';
import HorasExtras from './pages/HorasExtras';
import PlanVacaciones from './pages/PlanVacaciones';

// Import Components.
import Layout from './components/layout/Layout';

// Hooks
import useIdle from './hooks/useIdle';

// Redux
import { useDispatch } from 'react-redux';
import { setIdle } from '../src/redux/reducers/Idle.Slice';

function App() {
  const dispatch = useDispatch()
  const token = localStorage.getItem('accessToken')
  const accesos = JSON.parse(localStorage.getItem('user'))
  const permisos = accesos?.Permisos
  const pathUrl = window.location.pathname

  if (!token) {
    return <Login />
  }

  const handleLogout = () => {
    try {      
      console.log('Cerrando sesión...')
      
      setTimeout(() => {        
        localStorage.removeItem('accessToken')
        localStorage.removeItem('user')
        
        window.location.href = '/';
      }, 60000) // En 1 minuto se cerrará la sesión automáticamente.
    } catch (error) {
      console.error('Error al cerrar sesión:', error)
    }
  }
  
  const handleClosePage = () => {
    try {
      localStorage.setItem('noAutorizado', 'N')
      window.location.href = '/';
    } catch (error) {
      console.error('Error al cerrar sesión:', error)
    }
  }

  // Hook timer para una sesión activa.
  const { isIdle } = useIdle({ onIdle: handleLogout, idleTime: 30 }) // 30 minutos de inactividad.
  isIdle ? console.log('El usuario cerrará sesión') : console.log('El usuario está activo')

  useEffect(() => {
    if (isIdle) {
      dispatch(setIdle(true))
    }
  }
  , [isIdle, dispatch])

  let found;
  if (pathUrl !== '/') {
    for (let i = 0; i < permisos.length; i++) {
      const item = permisos[i];
      const subMenus = item.SubMenus
  
      if (!item.Path) {
        found = subMenus.find((element) => element.PathChild === pathUrl)
        
        if (found) break;
      } else {
        found = item.Path === pathUrl ? pathUrl : undefined
  
        if (found) break;
      }
    }
    
    if (!found) 
      handleClosePage()
  }

  return (
    <div className="wrapper">      
      <Router>
        <Routes>
          <Route path='/' element={<Layout />}>
            <Route index element={<Home />} />
            <Route path='/home' element={<Home />} />
                <Route path='/vacaciones' element={<Vacaciones />} />
                <Route path='/solicVacacion' element={<SolicVacacion />} />
            <Route path='/solicitudes' element={<Solicitudes />} />
            <Route path='/marcaciones' element={<Marcaciones />} />
            <Route path='/usuarios' element={<Usuarios />} />
            <Route path='/menus' element={<Menus />} />
            <Route path='/solicEmpleo' element={<SolicEmpleo />} />
            <Route path='/miPerfil' element={<MiPerfil />} />
            <Route path='/localizaciones' element={<Localizaciones />} />
            <Route path='/perfiles' element={<Perfiles />} />
            <Route path='/horasextras' element={<HorasExtras />} />
            <Route path='/planvacaciones' element={<PlanVacaciones />} />
          </Route>
        </Routes>
        <Outlet />
        <NotificationContainer />
      </Router>
    </div>
  );
}

export default App;